import { ColumnHelper } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";
import { ShortlistState } from "PFTypes";

import { isOpenVacancyItem, SuggestedWmTableItem } from "../types";
import { ShortlistStateCell } from "./shortlist_state_cell";

export const createShortlistStateColumn = (
  columnHelper: ColumnHelper<SuggestedWmTableItem>,
  headerLabel: string,
  getStateLabel: (state: ShortlistState) => string
) =>
  columnHelper.accessor((row) => (isOpenVacancyItem(row) ? undefined : row.state), {
    id: "shortlistState",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => {
      const item = info.row.original;
      if (isOpenVacancyItem(item)) {
        return null;
      }
      return <ShortlistStateCell shortlist={item} />;
    },
    sortingFn: (rowA, rowB) => {
      const stateA = isOpenVacancyItem(rowA.original)
        ? null
        : getStateLabel(rowA.original.state)?.toLowerCase();
      const stateB = isOpenVacancyItem(rowB.original)
        ? null
        : getStateLabel(rowB.original.state)?.toLowerCase();
      return (stateA ?? "").localeCompare(stateB ?? "");
    },
    sortUndefined: "last",
    size: 100
  });
